// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zt-U","clinicsSelect":"styles_clinicsSelect__C0mGO"};